import axios from 'axios';
import api from '@/lib/axios';
import { createUnitSettingsRequests } from './unitSettingsRequests.js';

// Preserve normal cookie authentication without replaying settings mutations.
const client = axios.create({ baseURL: api.defaults.baseURL, withCredentials: true, timeout: 60000,
  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
export const unitSettingsApi = createUnitSettingsRequests(client);
